/**
 * @voltxampere/ui — LM317 adjustable +5V default linear regulator (Sprint 40-2)
 *
 * TO-220 adjustable positive linear regulator. V_out is set
 * externally via the R1/R2 divider per V_out = 1.25 V × (1 + R2/R1).
 * Sprint 40 ships a nominal +5 V default (R1 = 240 Ω, R2 = 720 Ω
 * typical); runtime parameter binding (sense R-values + recompute
 * V_out) lands in Sprint 42+.
 *
 * Reference: TI LM317. Engine zero-diff invariant honored —
 * canonical "voltage-source" engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const regulatorLm317 = {
    id: "lm317",
    nameTr: "LM317 (Ayarlanabilir +5V, TO-220)",
    nameEn: "LM317 (Adjustable +5V, TO-220)",
    shortcut: "V",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "LM317",
    schemaType: "voltage-source",
    defaultParams: { voltage: 5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=regulator-lm317.js.map